import _ from 'lodash';
import React from 'react';

import {
  FormField,
  HelpBlock,
  InputFile,
  Label,
  Row,
} from './form';

export default function withNameFileInput(objectName, name, store, accept, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainInput() {
    const set = store(state => state.set);
    const errors = store(state => state.errors);
    const file = store(state => state[objectName][name]);
    const filename = store(state => state[objectName][`${name}Filename`]);

    const onChange = e => {
      e && e.preventDefault();

      const v = e.target.files[0];

      set(state => {
        state[objectName][name] = v;
      });
    };

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <FormField>
          <InputFile
            id={kebab}
            type="file"
            className="file"
            accept={accept || '*'}
            name={name}
            onChange={onChange}
          />
          {!!filename && !file && <span>{filename}</span>}
          {!!errors[snake] && <HelpBlock>{errors[snake]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainInput.displayName = capitalize;

  return PlainInput;
}
